import { z } from 'zod';

/** `/help?tour=<id>` opens the page and starts that tour (a shareable link). */
export const helpSearchSchema = z.object({
  tour: z.string().max(80).optional().catch(undefined),
});

export type HelpSearch = z.infer<typeof helpSearchSchema>;
